/*$(document).ready(function(){
    if (window.location.pathname.includes('/account/orders')) {
        skioCheckItems();
    }
});
$(window).on("load", function() {
    if (window.location.pathname.includes('/account/orders')) {
        hideOrderAgain();
    }
});

$('body').on('click', 'button[aria-label="Order history"]', function() {
    setTimeout(function () {
        skioCheckItems();
    }, 1000);
});*/

function skioCheckItems() {
    let maxTime = 4000;
    let countTime = 0;
    let initCheckSkioItems = setInterval(checkSkioItems, 50);

    function checkSkioItems() {
        countTime += 100;
        if ($('[data-testid="OrderCardContainer"]').length > 0){

            stopCheck();
            hideOrderAgain();
        }
        else if (countTime > maxTime){
            stopCheck();
        }
    }

    function stopCheck() {
        clearInterval(initCheckSkioItems);
    }

}

function hideOrderAgain() {
    if ($('[data-subbody-product-title-copy="thexcj.myshopify.com"]').length > 0) {
        $('[data-subbody-product-title-copy="thexcj.myshopify.com"]').each(function (ind, element) {
            let itemTitle = $(element).text().toLowerCase();

            if (itemTitle.includes('pre-order')) {
                let parentContainer = $(this).closest('[data-testid="OrderCardContainer"]');
                parentContainer.find('button[aria-label="Order again"]').remove();
            }
        });
    }
}


let observeElement = $('#layout--main-content')[0];
let observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
        if (mutation.type == 'childList') {
            hideOrderAgain();
        }
    });
});

observer.observe(
    observeElement,
    {
        childList: true,
        attributes: true,
        subtree: true,
        characterData: true,
        attributeOldValue: true,
        characterDataOldValue: true
    }
);